import { lazy } from "react";

import { Navigate } from "react-router-dom";

// Lazy load components for better performance
const GamesPage = lazy(() => import("@/routes/games/page"));
const NewGamePage = lazy(() => import("@/routes/games/new/page"));
const BootstrapGamePage = lazy(() => import("@/routes/games/bootstrap/page"));
const GamePage = lazy(() => import("@/routes/games/[id]/page"));
const EditGamePage = lazy(() => import("@/routes/games/[id]/edit/page"));
const BuildUploadPage = lazy(() => import("@/routes/games/[id]/builds/upload/page"));
const BuildEditPage = lazy(() => import("@/routes/games/[id]/builds/[buildId]/edit/page"));
const NewGameEntryPage = lazy(() => import("@/routes/games/[id]/entries/new/page"));
const EditGameEntryPage = lazy(() => import("@/routes/games/[id]/entries/edit/page"));
const DownloadsPage = lazy(() => import("@/routes/downloads/page"));
const StudioPage = lazy(() => import("@/routes/studio/page"));
const StudioReviewPage = lazy(() => import("@/routes/studio/review/page"));

// Auth pages
const SignIn = lazy(() => import("@/routes/auth/sign-in/page"));

// Error pages
const Unauthorized = lazy(() => import("@/routes/errors/unauthorized/page"));
const Forbidden = lazy(() => import("@/routes/errors/forbidden/page"));
const NotFound = lazy(() => import("@/routes/errors/not-found/page"));
const InternalServerError = lazy(() => import("@/routes/errors/internal-server-error/page"));
const UnderMaintenance = lazy(() => import("@/routes/errors/under-maintenance/page"));

export interface RouteConfig {
  path: string;
  element: React.ReactNode;
  children?: RouteConfig[];
}

export const routes: RouteConfig[] = [
  // Default route - redirect to games
  {
    path: "/",
    element: <Navigate to="games" replace />,
  },
  // Dashboard Routes - redirects to games (kept for future use)
  {
    path: "/dashboard",
    element: <Navigate to="/games" replace />,
  },
  {
    path: "/games",
    element: <GamesPage />,
  },
  {
    path: "/downloads",
    element: <DownloadsPage />,
  },
  {
    path: "/studio",
    element: <StudioPage />,
  },
  {
    path: "/studio/review",
    element: <StudioReviewPage />,
  },
  {
    path: "/games/new",
    element: <NewGamePage />,
  },
  {
    path: "/games/bootstrap",
    element: <BootstrapGamePage />,
  },
  {
    path: "/games/:gameId/entries/:entryId/edit",
    element: <EditGameEntryPage />,
  },
  {
    path: "/games/:id/entries/new",
    element: <NewGameEntryPage />,
  },
  {
    path: "/games/:id/builds/upload",
    element: <BuildUploadPage />,
  },
  {
    path: "/games/:id/builds/:buildId/edit",
    element: <BuildEditPage />,
  },
  {
    path: "/games/:id/edit",
    element: <EditGamePage />,
  },
  {
    path: "/games/:id",
    element: <GamePage />,
  },

  // Authentication Routes
  {
    path: "/auth/sign-in",
    element: <SignIn />,
  },

  // Error Pages
  {
    path: "/errors/unauthorized",
    element: <Unauthorized />,
  },
  {
    path: "/errors/forbidden",
    element: <Forbidden />,
  },
  {
    path: "/errors/not-found",
    element: <NotFound />,
  },
  {
    path: "/errors/internal-server-error",
    element: <InternalServerError />,
  },
  {
    path: "/errors/under-maintenance",
    element: <UnderMaintenance />,
  },

  // Catch-all route for 404
  {
    path: "*",
    element: <NotFound />,
  },
];
